"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.get = void 0;
var _toolkit = require("@reduxjs/toolkit");
var _decimal = _interopRequireDefault(require("decimal.js"));
var _actions = require("../../actions");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var initialState = {
  loading: false
};
var get = (0, _toolkit.createReducer)(initialState, function (builder) {
  builder.addCase(_actions.getBalancesAction.pending, function () {
    return _objectSpread(_objectSpread({}, initialState), {}, {
      loading: true
    });
  });
  builder.addCase(_actions.getBalancesAction.rejected, function (state) {
    state.loading = false;
  });
  builder.addCase(_actions.getBalancesAction.fulfilled, function (state, action) {
    state.loading = false;
    state.data = action.payload.sort(function (prevBalance, nextBalance) {
      return Number(nextBalance.converted) - Number(prevBalance.converted);
    });
  });
  builder.addCase(_actions.recalculateBalancesAction, function (state, action) {
    var _state$data;
    var foundBalance = (_state$data = state.data) === null || _state$data === void 0 ? void 0 : _state$data.find(function (balance) {
      return balance.ticker === action.payload.ticker;
    });
    if (foundBalance) {
      Object.assign(foundBalance, {
        value: new _decimal.default(foundBalance.value)[action.payload.increase ? 'add' : 'sub'](action.payload.value).toString(),
        converted: new _decimal.default(foundBalance.converted)[action.payload.increase ? 'add' : 'sub'](action.payload.convertedValue).toString()
      });
    }
  });
});
exports.get = get;